export const config = {
    apiUrl: process.env.REACT_APP_API_URL || '',
    siteUrl: process.env.REACT_APP_SITE_URL || '',
    stripeKey: process.env.REACT_APP_STRIPE_KEY || '',
    pusherSocket: process.env.REACT_APP_PUSHER_SOCKET || '',
};
